import {
  GET_PAYMENT_METHOD_DEF,
  GET_PAYMENT_METHOD_DEF_SUCCESS,
  API_ERROR
  
  } from "./actionTypes"
  
    
  export const getPaymentMethodDef = () => ({
    type: GET_PAYMENT_METHOD_DEF,
  })
  
  export const getPaymentMethodDefSuccess = record => ({
    type: GET_PAYMENT_METHOD_DEF_SUCCESS,
    payload: record,
  })
  
  export const paymentMethodDefError = error => {
    return {
      type: API_ERROR,
      payload: error,
    }
  }
  
  